class TiktokModal extends HTMLElement {
  constructor() {
    super();

    this.closeModalTrigger = this.querySelector('[data-modal-close]');
    this.modal = this.querySelector('[data-modal]');

    this.listeners();
  }

  listeners() {

    this.closeModalTrigger.addEventListener('click', this.closeModal.bind(this));

    document.addEventListener('keydown', (e) => {
      if (e.key == "Escape") {
        this.closeModal();
      }
    })
  }

  openModal() {
    this.modal.setAttribute('aria-hidden', false);
    this.embedVideo();
  }

  closeModal() {
    this.modal.setAttribute('aria-hidden', true);
  }

  // async getEmbedHTML() {
  //   const response = await fetch(`https://www.tiktok.com/oembed?url=${this.dataset.url}`, { method: 'GET' });
  //   const responseJSON = await response.json();

  //   return responseJSON;
  // }

  // async embedVideo() {

  //   const embed = this.querySelector('[data-embed]') || false;

  //   if (embed.children.length > 0 || embed == false) return;

  //   const embedHTML = await this.getEmbedHTML();

  //   if (embedHTML) {
  //     console.log("embedHTML: ", embedHTML);
  //     embed.innerHTML = embedHTML.html;

  //     Array.from(embed.querySelectorAll("script")).forEach(oldScriptEl => {
  //       const newScriptEl = document.createElement("script");

  //       Array.from(oldScriptEl.attributes).forEach(attr => {
  //         newScriptEl.setAttribute(attr.name, attr.value)
  //       });

  //       const scriptText = document.createTextNode(oldScriptEl.innerHTML);
  //       newScriptEl.appendChild(scriptText);

  //       oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
  //     });
  //   }
  // }
}

customElements.define('tiktok-modal', TiktokModal);